import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { DiscountGroupsComponent } from './discount-groups.component'
import { CreateDiscountGroupComponent } from './create-discount-group/create-discount-group.component'
import { UpdateDiscountGroupComponent } from './update-discount-group/update-discount-group.component'
import { discountGroupsRoutes } from './discount-groups.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '@shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    DiscountGroupsComponent,
    CreateDiscountGroupComponent,
    UpdateDiscountGroupComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(discountGroupsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [
    DiscountGroupsComponent,
    CreateDiscountGroupComponent,
    UpdateDiscountGroupComponent,
  ],
})
export class DiscountGroupsModule {}
